/** Error shown inside the app frame when a page fails (instead of the router's blank default page). */
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';
import { isChunkLoadError } from '@/utils/app-version';
import { t } from '@/i18n/ar';

export function RouteError() {
  const error = useRouteError();
  const navigate = useNavigate();
  const newVersion = isChunkLoadError(error);
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  return (
    <div role="alert" className="card mx-auto mt-6 max-w-lg p-8 text-center">
      <div className="mb-2 text-lg font-extrabold text-[#5C1528]">
        {newVersion ? t.newVersionTitle : notFound ? t.notFound : t.pageErrorTitle}
      </div>
      <p className="mb-5 text-sm text-[#a84d62]">{newVersion ? t.newVersionText : t.pageErrorText}</p>
      <div className="flex flex-wrap justify-center gap-2">
        <button type="button" className="btn-p" onClick={() => window.location.reload()}>
          {t.reloadPage}
        </button>
        <button type="button" className="btn-o" onClick={() => navigate('/')}>
          {t.backToDashboard}
        </button>
      </div>
    </div>
  );
}
